import { COLLAB_CONSTANTS } from "./constants";
import MagnifiedImageFrame from "@/components/magnifyImageFrame";

const AboutComp = () => {
  return <MagnifiedImageFrame {...COLLAB_CONSTANTS} />;
};

export default AboutComp;
